import DoorList from './DoorList'
import styled from 'styled-components'
import RootNaviView from './RootNaviView'
import { useParams } from 'react-router'
import React, { useEffect, useState } from 'react'
import { getKeyword, getKeywordDoors } from 'apis/keywords'
import { Keyword } from 'apis/response_types'
import {} from 'axios'
import MetaTag from 'components/common/MetaTag'
import BreadCrumbs, { BreadCrumb } from 'components/common/BreadCrumbs'
interface RouteParams {
  keyword: string
}

export default function KeywordDoorList() {
  const params = useParams<RouteParams>()
  const [keyword, setKeyword] = useState<string>('')
  const [keywordResponse, setKeywordResponse] = useState<Keyword | null>(null)
  const [loading, setLoading] = useState(true)
  const breadcrumbsList: BreadCrumb[] = [
    { name: 'キーワード一覧', to: '/keyword' },
    { name: keywordResponse?.word || '' }
  ]

  // Doorの表示件数をスマホは12件, PCは15件に設定
  const per = window.innerWidth < 640 ? 12 : 15

  const get = async () => {
    getKeyword(params.keyword)
      .then((response) => {
        setKeywordResponse(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  useEffect(() => {
    get()
  }, [])

  useEffect(() => {
    setKeyword(params.keyword)
    get()
  }, [params.keyword])

  return (
    <React.Fragment>
      {!loading &&
        (keywordResponse ? (
          <>
            <MetaTag
              title={`${keywordResponse.word} - オンラインサロンYOOR（ユア）`}
              description={`${keywordResponse.word}のオンラインサロン一覧です。YOORは、サロン専用トークルームを完備した、コミュニティやファンクラブ、オンラインレッスンの場として利用できる業界初AI機能搭載のオンラインサロンプラットフォームです。`}
            />
            <BreadCrumbsStyled breadcrumbsList={breadcrumbsList} />
            <DoorList
              title={`${keywordResponse.word}`}
              textAlign={'left'}
              keyword={keyword}
              errorMessage={'キーワードと一致するサロンはありませんでした。'}
              listAPI={(page: number, keyword?: string) => {
                return getKeywordDoors(page, keyword, per)
              }}
            />
          </>
        ) : (
          <div>
            <MetaTag title={`${keyword} - オンラインサロンYOOR（ユア）`} />
            <div
              className="section-base section-recommend pt30"
              id="a-recommend"
            >
              <div className="section-inner">
                <div className="error-message">
                  <div className="title">
                    お探しのキーワードはありませんでした。
                  </div>
                  <div className="message">
                    <p>
                      「キーワードが既に削除されている」「アクセスしたアドレスが異なっている」などの理由で見つかりませんでした。
                    </p>
                    <p>以下のページからキーワードを探すことができます。</p>
                    <p className="link">
                      <a href="/keyword">もっとキーワードを見る</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </React.Fragment>
  )
}

const BreadCrumbsStyled = styled(BreadCrumbs)`
  max-width: 1200px;
  margin: 24px auto 0;
  @media (max-width: 640px) {
    margin: 0 auto;
    padding: 12px 20px 0;
  }
`